import { HttpErrorModel } from '@spartacus/core';
import { BetonActions } from '../actions';

export const initialState: HttpErrorModel = undefined;

export function calculateOrderErrorReducer(
  state = initialState,
  action:
    | BetonActions.CalculateBetonOrderFail
    | BetonActions.CalculateBetonOrderSuccess
    | BetonActions.ResetBetonOrderCalcData,
): HttpErrorModel {
  switch (action.type) {
    case BetonActions.CALCULATE_BETON_ORDER_FAIL: {
      return action.payload;
    }

    case BetonActions.CALCULATE_BETON_ORDER_SUCCESS:
    case BetonActions.RESET_BETON_ORDER_CALC_DATA: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
